/** Hide the bar and mark which ends still have content off-screen. */
export function bindScrollEdges(scroller: HTMLElement): () => void {
  const host = scroller.parentElement;
  if (!host?.classList.contains("sfe-scroll-edges")) return () => {};

  const update = (): void => {
    const max = scroller.scrollWidth - scroller.clientWidth;
    host.classList.toggle("is-more-start", scroller.scrollLeft > 2);
    host.classList.toggle("is-more-end", max - scroller.scrollLeft > 2);
  };

  scroller.addEventListener("scroll", update, { passive: true });
  const resize = new ResizeObserver(update);
  resize.observe(scroller);
  const content = new MutationObserver(update);
  content.observe(scroller, { childList: true, subtree: true });
  update();

  return () => {
    scroller.removeEventListener("scroll", update);
    resize.disconnect();
    content.disconnect();
  };
}
